import { render, staticRenderFns } from "./LogisticsLayout.vue?vue&type=template&id=47425f0d&scoped=true&"
import script from "./LogisticsLayout.vue?vue&type=script&lang=js&"
export * from "./LogisticsLayout.vue?vue&type=script&lang=js&"
import style0 from "./LogisticsLayout.vue?vue&type=style&index=0&id=47425f0d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47425f0d",
  null
  
)

export default component.exports